import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PageNotFound } from '../../PageNotFound';
import { LanguageLearningBundlesPage } from './LanguageLearningBundlesPage';
import { CheckLoanFormat } from '../../../shared/components/CheckLoanFormat';

export const BundlesRouteSwitch = () => {
    return (
        <Routes>
            <Route index element={<Navigate to="all" replace />} />
            <Route
                path=":loanFormat"
                element={
                    <CheckLoanFormat>
                        <LanguageLearningBundlesPage />
                    </CheckLoanFormat>
                }
            />
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
};
